import { logDataToConsole, logError } from "../../../medonc/utils/customLogger";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export interface IngestPdfCsvNarGridPayload {
  file_url?: string;
  file_type: string;
  file_path?: string;
  ingest: boolean;
  payer_type: string;
  effective_date: string;
  sub_type: string;
  version: string;
  artifact_creation_date: string;
  bigquery_table: string;
  bigquery_dataset: string;
  client_bigquery_table: string;
  /** When true, ingested rows use the never-expire end date. Defaults to false. */
  never_expire?: boolean;
  /** 1-indexed start page for PDF ingestion; overrides the stored pdf config. */
  start_page?: number;
  /** 1-indexed inclusive end page for PDF ingestion; overrides the stored pdf config. */
  end_page?: number;
}

export interface IngestPdfCsvNarGridResponse {
  success: boolean;
  data?: any;
  message?: string;
}

export const ingestPdfCsvNarGrid = async (
  payload: IngestPdfCsvNarGridPayload,
): Promise<IngestPdfCsvNarGridResponse> => {
  try {
    logDataToConsole(
      "Making ingest PDF/CSV NAR grid API call with payload",
      payload,
    );

    const token = await getBearerToken();

    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.INGEST_PDF_CSV_NAR_GRID, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      logError(
        new Error(
          `Ingest PDF/CSV NAR grid API call failed: ${response.status} ${response.statusText}`,
        ),
        errorText,
      );
      return {
        success: false,
        message: `Request failed with status ${response.status}: ${response.statusText}`,
      };
    }

    const responseData = await response.json();
    logDataToConsole(
      "Ingest PDF/CSV NAR grid API call successful",
      responseData,
    );

    return {
      success: true,
      data: responseData,
    };
  } catch (error) {
    logError(error as Error, "Error in ingestPdfCsvNarGrid");
    return {
      success: false,
      message:
        error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
};
